import React from "react";
import { Box, Grid, InputLabel, MenuItem } from "@mui/material";

import { CustomInput } from "../../../../../../components/Custom/Input";
import styles from "../../sessions.module.css";
import type { PositionFormik } from "./positionForm.types";
import { FieldError, OutlinedSelect } from "./PositionFormFields";
import { ATTIRE_OPTIONS, COMPLEXITY_OPTIONS } from "./positionForm.utils";

const COMPLEXITY_PLACEHOLDER = "Search Complexity";
const ATTIRE_PLACEHOLDER = "Search Attire";
const DEFAULT_ATTIRE = "Tech Blacks";

type PositionDetailsFieldsProps = {
  formik: PositionFormik;
  fullWidthComplexity?: boolean;
  compactTop?: boolean;
};

/** Complexity, attire and comments: the same for every shift of the position. */
const PositionDetailsFields = ({
  formik,
  fullWidthComplexity = false,
  compactTop = false,
}: PositionDetailsFieldsProps) => {
  const { values, touched, errors, handleChange, handleBlur } = formik;

  return (
    <>
      <Grid
        item
        sx={{
          width: fullWidthComplexity ? "100%" : "50%",
          ...(compactTop ? { paddingTop: "0.5rem !important" } : {}),
          "@media (max-width: 600px)": { width: "100%" },
        }}
      >
        <Box className={styles["form-box"]}>
          <InputLabel>Complexity</InputLabel>
          <OutlinedSelect
            name="complexity"
            value={values?.complexity || COMPLEXITY_PLACEHOLDER}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <MenuItem className={styles.option} value={COMPLEXITY_PLACEHOLDER} disabled>
              {COMPLEXITY_PLACEHOLDER}
            </MenuItem>
            {COMPLEXITY_OPTIONS.map((complexity) => (
              <MenuItem key={complexity} value={complexity} className={styles.option}>
                {complexity}
              </MenuItem>
            ))}
          </OutlinedSelect>
          <FieldError show={touched?.complexity} message={errors?.complexity} />
        </Box>
      </Grid>

      <Grid item sx={{ width: "100%" }}>
        <Box className={styles["form-box"]}>
          <InputLabel>Attire</InputLabel>
          <OutlinedSelect
            name="attire"
            value={values?.attire || DEFAULT_ATTIRE}
            onChange={handleChange}
            onBlur={handleBlur}
          >
            <MenuItem className={styles.option} value={ATTIRE_PLACEHOLDER} disabled>
              {ATTIRE_PLACEHOLDER}
            </MenuItem>
            {ATTIRE_OPTIONS.map((attire) => (
              <MenuItem key={attire} className={styles.option} value={attire}>
                {attire}
              </MenuItem>
            ))}
          </OutlinedSelect>
          <FieldError show={touched?.attire} message={errors?.attire} />
        </Box>
      </Grid>

      <Grid item sx={{ width: "100%" }}>
        <Box className={styles["form-box"]}>
          <InputLabel>Additional Comments</InputLabel>
          <CustomInput
            fullWidth
            placeholder="Type Here"
            name="comments"
            value={values?.comments}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <FieldError show={touched?.comments} message={errors?.comments} />
        </Box>
      </Grid>
    </>
  );
};

export default PositionDetailsFields;
